module.exports = __webpack_public_path__ + "static/media/IMG4.2399b8d4.jpg";